import DataStore from 'src/core/stores/data-store';

export interface ImportExportDevLogSummary {
  id: string;
  date: Date;
  statusCode: number;
  message: string;
  traceId: string;
  trace: string;
}

export interface ScopeLogSummary {
  id: string;
  scopeId: string;
  date: Date;
  previousParentId: string;
  currentParentId: string;
  previousHierarchy: string;
  currentHierarchy: string;
  source: string;
  scopeLogType: ScopeLogType;
  scopeLogDescendants: ScopeLogDescendant[];
}

export interface ScopeLogDescendant {
  id: string;
  scopeId: string;
  currentParentId: string;
  previousHierarchy: string;
  currentHierarchy: string;
}

export enum ScopeLogType {
  Update,
  Delete,
}

export class ImportExportDevLogsStore extends DataStore<ImportExportDevLogSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/export-import/api/logs`, []);
  }
}

export class ScopeLogsStore extends DataStore<ScopeLogSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/identity/api/scope-logs`, []);
  }
}
